/*jshint esversion: 6 */

import React from 'react';
import CaSlideGallery from './../general/CaSlideGallery';


const CaProfileAwardsView = (props) => {
    const { tier, handleItemClick, header } = props;
    const { awards, title, content } = tier;
    const items = awards.map((item, index) => (
        <div onClick={() => handleItemClick(item)} key={index} className={"SlideGallery__item"} >
            <div className={"ProfileAwards__backgroundImage SlideGallery__backgroundImage"} style={{ backgroundImage: ("url(" + item.image + ")") }} />
            <div className={"ProfileAwards__caption"}>{item.title}</div>
        </div>
    ));

    return (
        <div className={"ProfileAwards ProfilePageBlock"}>
            <div className={"ProfileAwards__content"}>
                <CaSlideGallery items={items} title={header} body={content} classNamePrepend={"ProfileAwards"} />
            </div>
            <div className={"ProfilePageDivider"}></div>
        </div>

    )
};

export default CaProfileAwardsView;




